/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './ui_element';
import './rich_text';
import '../common/glyph/glyph_icon';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "OnboardingSplash": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "title": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "message": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "topImage": {
                        "type": "squareup.bbfrontend.service.v1.UiElement.ImageElement",
                        "id": 4,
                        "rule": "optional"
                      },
                      "sellItems": {
                        "type": "squareup.bbfrontend.service.v1.OnboardingSplash.SellItem",
                        "id": 5,
                        "rule": "repeated"
                      },
                      "continueButton": {
                        "type": "squareup.bbfrontend.service.v1.UiElement.ButtonElement",
                        "id": 6,
                        "rule": "optional"
                      },
                      "termsOfServiceText": {
                        "type": "squareup.bbfrontend.service.v1.RichText",
                        "id": 7,
                        "rule": "optional"
                      },
                      "footerText": {
                        "type": "squareup.bbfrontend.service.v1.RichText",
                        "id": 8,
                        "rule": "optional"
                      },
                      "inlineImage": {
                        "type": "squareup.bbfrontend.service.v1.UiElement.ImageElement",
                        "id": 9,
                        "rule": "optional"
                      },
                      "callToActionLocation": {
                        "type": "squareup.bbfrontend.service.v1.OnboardingSplash.CallToActionLocation",
                        "id": 10,
                        "rule": "optional",
                        "options": {
                          "default": "TOP"
                        }
                      },
                      "titleSize": {
                        "type": "squareup.bbfrontend.service.v1.OnboardingSplash.TitleSize",
                        "id": 11,
                        "rule": "optional",
                        "options": {
                          "default": "LARGE"
                        }
                      }
                    },
                    "nested": {
                      "CallToActionLocation": {
                        "values": {
                          "TOP": 0,
                          "BOTTOM": 1
                        }
                      },
                      "TitleSize": {
                        "values": {
                          "LARGE": 1,
                          "MEDIUM": 2
                        }
                      },
                      "SellItem": {
                        "fields": {
                          "message": {
                            "type": "string",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "glyph": {
                            "type": "squareup.bbfrontend.common.glyph.GlyphIcon",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingSplash && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingSplash?.nested?.CallToActionLocation && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingSplash?.nested?.TitleSize && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingSplash?.nested?.SellItem) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE OnboardingSplash @ squareup/bbfrontend/v1/onboarding_splash.proto at 14:1
 */
export const OnboardingSplash = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingSplash');
fixType(OnboardingSplash, {
  id: {
    notEmpty: true
  },
  title: {
    notEmpty: true
  },
  continueButton: {
    required: true
  }
});
Builder.createAndAttachToType(OnboardingSplash);
/**
 * SOURCE CallToActionLocation @ squareup/bbfrontend/v1/onboarding_splash.proto at 41:3
 */
OnboardingSplash.CallToActionLocation = $root.lookupEnum('squareup.bbfrontend.service.v1.OnboardingSplash.CallToActionLocation').values;
/**
 * SOURCE TitleSize @ squareup/bbfrontend/v1/onboarding_splash.proto at 46:3
 */
OnboardingSplash.TitleSize = $root.lookupEnum('squareup.bbfrontend.service.v1.OnboardingSplash.TitleSize').values;
/**
 * SOURCE SellItem @ squareup/bbfrontend/v1/onboarding_splash.proto at 51:3
 */
OnboardingSplash.SellItem = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingSplash.SellItem');
fixType(OnboardingSplash.SellItem, {
  message: {
    required: true
  },
  glyph: {
    required: true
  }
});
Builder.createAndAttachToType(OnboardingSplash.SellItem);